import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/utils/analytics";

/**
 * Mount once near the app root. Initializes GA4 (no-op if ID unset),
 * and fires a page_view on every SPA route change — excluding authenticated/PHI pages.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    // Small delay so document.title has been updated by any page-level useEffect
    const t = setTimeout(() => trackPageView(location.pathname), 50);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return null;
}
